import { defineStore } from 'pinia';

import { createdCampaigns } from '../resources/js/api/crowdpacs.js';

export const useCampaignStore = defineStore('campaign', {
  state: () => {
    return {
      isCampaignSection: false,
      userHasCreatedCampaigns: false,
      userCampaignList: [],
      campaignsLoaded: false,
      coachEligibleCampaignList: [],
      coachEligibleCampaignsLoaded: false,
    };
  },
  getters: {
    mostRecentCampaign(state) {
      return state.userCampaignList[0] || null;
    },
    mostRecentCampaignDashboardUrl(state) {
      const campaign = state.userCampaignList[0];
      return campaign?.id ? `/user/campaigns/${campaign.id}/dashboard` : null;
    },
    mostRecentCoachEligibleCampaign(state) {
      return state.coachEligibleCampaignList[0] || null;
    },
    mostRecentCoachEligibleCampaignDashboardUrl(state) {
      const campaign = state.coachEligibleCampaignList[0];
      return campaign?.id ? `/user/campaigns/${campaign.id}/dashboard` : null;
    },
  },
  actions: {
    setIsCampaignSection(val) {
      this.isCampaignSection = val;
    },
    getCreatedCampaigns() {
      createdCampaigns()
        .then(res => {
          this.userHasCreatedCampaigns = res.crowdpacs_created;
        })
        .catch(error => {
          console.warn(error);
        });
    },
    async getUserCampaigns(force = false) {
      if (this.campaignsLoaded && !force) {
        return;
      }
      try {
        const res = await createdCampaigns({ list: true });
        this.userCampaignList = res.crowdpacs || [];
        this.userHasCreatedCampaigns = res.crowdpacs.length > 0;
        this.campaignsLoaded = true;
      } catch (error) {
        console.warn(error);
      }
    },
    async getCoachEligibleCampaigns(force = false) {
      if (this.coachEligibleCampaignsLoaded && !force) {
        return;
      }
      try {
        const res = await createdCampaigns({ list: true, for_campaign_coach: true });
        this.coachEligibleCampaignList = res.crowdpacs || [];
        this.coachEligibleCampaignsLoaded = true;
      } catch (error) {
        console.warn(error);
      }
    },
    resetCampaignsCache() {
      this.campaignsLoaded = false;
      this.userCampaignList = [];
      this.coachEligibleCampaignsLoaded = false;
      this.coachEligibleCampaignList = [];
    },
  },
});
